var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfContainedEmergencyLight01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.54,13.38H2.46V2.31h11.08V13.38z M2.96,12.88h10.08V2.81H2.96V12.88z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.79,
    y: 0.47,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.2228 7.9993)",
    className: "st2",
    width: 0.5,
    height: 14.83
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.52,
    y: 7.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.2046 7.9549)",
    className: "st2",
    width: 14.96,
    height: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8.04,
    cy: 7.89,
    r: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.04,9.21c-0.73,0-1.32-0.59-1.32-1.32s0.59-1.32,1.32-1.32s1.32,0.59,1.32,1.32S8.77,9.21,8.04,9.21z  M8.04,7.07c-0.45,0-0.82,0.37-0.82,0.82s0.37,0.82,0.82,0.82s0.82-0.37,0.82-0.82S8.5,7.07,8.04,7.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfContainedEmergencyLight01);
export default __webpack_public_path__ + "static/media/SelfContainedEmergencyLight-01.919b5143b14de304dd67867a9113a532.svg";
export { ForwardRef as ReactComponent };